document.addEventListener("DOMContentLoaded", function(){
    const accordionBlocks = document.querySelectorAll('.accordion-block')
    accordionBlocks.forEach((accordionBlock) => {
        const numbers = accordionBlock.querySelectorAll('.accordion-block__number')
        if(numbers.length){
            numbers.forEach((number, index) => {
                // Add the accordion number
                number.innerHTML = index + 1
            })
        }
    })
})